import React from 'react';
import { Link } from 'react-router-dom';

import breadcrumbBG from '../../assets/img/breadcrumb/bg.jpg';
import shapeImg from '../../assets/img/breadcrumb/shape-1.png';

const Breadcrumb = (props) => {
  const { itemClass, title, subTitle } = props;
  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'it-breadcrumb-area fix it-breadcrumb-bg p-relative'
      }
      style={{ backgroundImage: `url(${breadcrumbBG})` }}
    >
      <div className="it-breadcrumb-shape-1">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row ">
          <div className="col-md-12">
            <div className="it-breadcrumb-content z-index-3">
              <div className="it-breadcrumb-title-box">
                <h3 className="it-breadcrumb-title">
                  {title ? title : 'About Us'}
                </h3>
              </div>
              <div className="it-breadcrumb-list-wrap">
                <div className="it-breadcrumb-list">
                  <span>
                    <Link to="/">home</Link>
                  </span>
                  <span className="dvdr">//</span>
                  <i>{subTitle ? subTitle : title ? title : 'about us'}</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
